import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Button } from '@mui/material';
export const ManagerSetupAlert = ({ onOpenManagerSettingsModal, }) => {
    return (_jsx(Alert, { severity: "info", action: _jsx(Button, { size: "small", color: "primary", variant: "contained", onClick: onOpenManagerSettingsModal, children: "Add" }), children: "Add a manager's details to enable this feature." }));
};
